import { ExportToCsv } from 'export-to-csv';

export default function exportToCSV(responseData, columns, exportFilename, title) {
    const formattedData = responseData.map(item =>
    Object.fromEntries(columns.map(col => [col.title, item[col.key] || ""]))
  );
  
    const options = {
        fieldSeparator: ',',
        quoteStrings: '"',
        decimalSeparator: '.',
        showLabels: true,
        showTitle: true,
        useTextFile: false,
        filename: exportFilename || 'report',
        useBom: true,
        useKeysAsHeaders: true,
        ...(title ? { title } : {})
    };

    const csvExporter = new ExportToCsv(options);
    
    csvExporter.generateCsv(formattedData);
}

